import { render, staticRenderFns } from "./TheProductListColumnMode.vue?vue&type=template&id=87c19edc&"
import script from "./TheProductListColumnMode.vue?vue&type=script&lang=js&"
export * from "./TheProductListColumnMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87c19edc')) {
      api.createRecord('87c19edc', component.options)
    } else {
      api.reload('87c19edc', component.options)
    }
    module.hot.accept("./TheProductListColumnMode.vue?vue&type=template&id=87c19edc&", function () {
      api.rerender('87c19edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductListColumnMode.vue"
export default component.exports